import React from 'react';
import { Icon } from 'antd';
import PropTypes from 'prop-types';

export default function NotAllow(props) {
  const { style } = props;
  return (
    <div style={style || {}}>
      <h4>
        <Icon
          style={{ color: 'red', fontSize: 16 }}
          type="warning"
        />
        Bạn không được cấp quyền để truy cập nội dung này.
      </h4>
    </div>
  );
}

NotAllow.propTypes = {
  style: PropTypes.string
};

NotAllow.defaultProps = {
  style: ''
};
